import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { BaseElement } from "../../utils/ui-components.js";
import { Country, countryName } from "../../model/country.js";
import { Platform } from "../../model/platform.js";

@customElement("api-docs-reference")
export class ApiDocsReference extends BaseElement {
    connectedCallback() {
        super.connectedCallback();
        this.style.display = "block";
    }

    private get countries(): { code: string; name: string }[] {
        return Object.values(Country)
            .map((code) => ({
                code,
                name: countryName(code),
            }))
            .sort((a, b) => a.name.localeCompare(b.name));
    }

    private get platforms(): { value: string; description: string }[] {
        return [
            { value: Platform.iPhone, description: "iPhone App Store" },
            { value: Platform.iPad, description: "iPad App Store" },
        ];
    }

    render() {
        return html`
            <section class="space-y-4">
                <h2 class="text-2xl font-bold">Reference</h2>

                <h3 class="text-lg font-semibold">Platforms</h3>
                <div class="overflow-x-auto">
                    <table class="table table-sm">
                        <thead>
                            <tr>
                                <th>Value</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${this.platforms.map(
                                (p) => html`
                                    <tr>
                                        <td><code>${p.value}</code></td>
                                        <td>${p.description}</td>
                                    </tr>
                                `
                            )}
                        </tbody>
                    </table>
                </div>

                <h3 class="text-lg font-semibold">Countries</h3>
                <p>Pass the two-letter code as the <code>country</code> parameter.</p>
                <div class="overflow-x-auto max-h-96">
                    <table class="table table-sm table-pin-rows">
                        <thead>
                            <tr>
                                <th>Code</th>
                                <th>Country</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${this.countries.map(
                                (c) => html`
                                    <tr>
                                        <td><code>${c.code}</code></td>
                                        <td>${c.name}</td>
                                    </tr>
                                `
                            )}
                        </tbody>
                    </table>
                </div>
            </section>
        `;
    }
}
